import { usePopoverShown } from "../../../../utility/knowledgeBase/usePopoverShown"
import PopoverTrigger from "../../../PopoverTrigger/PopoverTrigger"
import styles from "./Sticker.module.scss"
import { Sticker as StickerModel } from "../../../../models/sticker"
import { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import ArticleStickerPopover from "../../../StickerPopover/ArticleStickerPopover"

type Props = {
    id: string
    isEditable: boolean
    onChange: (id?: string) => void
    stickers: StickerModel[]
}

const tNamespace = "knowledgeBase:sticker."

export const getStickerUrl = (id: string, stickers: StickerModel[]) =>
    stickers?.find((sticker: StickerModel) => sticker.Id === id)?.StickerUrl || ""

export const Sticker: React.FC<Props> = props => {
    const { id, isEditable, onChange, stickers } = props

    const url = getStickerUrl(id, stickers)

    const { shown, showPopover, hidePopover } = usePopoverShown()
    const { t } = useTranslation()

    const popoverRef = useRef<HTMLDivElement>(null)
    const handleClickOutside = (event: MouseEvent) => {
        if (popoverRef.current && event.target instanceof Node && !popoverRef.current.contains(event.target)) {
            hidePopover()
            onChange()
        }
    }

    const handleChooseSticker = (sticker: StickerModel) => {
        onChange(sticker.Id)
        hidePopover()
    }

    useEffect(() => {
        !url && isEditable && showPopover()

        return () => {
            if (isEditable) {
                hidePopover()
                onChange()
            }
        }
    }, [])

    useEffect(() => {
        if (shown) {
            document.addEventListener("mousedown", handleClickOutside)
        } else {
            document.removeEventListener("mousedown", handleClickOutside)
        }
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [shown])

    return (
        <>
            {url || !isEditable ? (
                <img src={url} className={styles.markdownSticker} />
            ) : (
                <PopoverTrigger
                    id={"popover-trigger"}
                    show={shown && isEditable}
                    content={
                        <ArticleStickerPopover setSticker={handleChooseSticker} stickers={stickers} ref={popoverRef} />
                    }
                    placement={"auto"}
                    className={styles.popover}
                >
                    <div className={styles.stickerPlaceholder}>{t(`${tNamespace}insert`)}</div>
                </PopoverTrigger>
            )}
        </>
    )
}
